import { ConstructionOutlined } from '@mui/icons-material';
import axios from './axios';

export const initialState = {
  user: null,
  refreshApplicant: 0,
  globalAccountSelected: null,
  showNotification: { show: false, title: "", content: "", success: true },
  showProcessing: { show: false, title: "" },
  applicantDetails: {},
  activeStep: 0,
  goToStep: { go: false, targetStep: 0 },
  progressStep: 0,
  hideHauling: 0
};

export const actionTypes = {
  SET_USER: "SET_USER",
  SET_REFRESH_APPLICANT: "SET_REFRESH_APPLICANT",
  SET_GLOBAL_ACCOUNT_SELECTED: "SET_GLOBAL_ACCOUNT_SELECTED",
  SET_SHOW_NOTIFICATION: "SET_SHOW_NOTIFICATION",
  SET_SHOW_PROCESSING: "SET_SHOW_PROCESSING",
  SET_APPLICANT_DETAILS: "SET_APPLICANT_DETAILS",
  SET_ACTIVE_STEP: "SET_ACTIVE_STEP",
  INIT_APPLICANT_DETAILS: "INIT_APPLICANT_DETAILS",
  SET_SUBMIT_APPLICANT_DETAILS: "SET_SUBMIT_APPLICANT_DETAILS",
  SET_GO_TO_STEP: "SET_GO_TO_STEP",
  SET_PROGRESS_STEP: "SET_PROGRESS_STEP",
  SET_HIDE_HAULING: "SET_HIDE_HAULING"
};

const reducer = (state, action) => {

  const applicationSubmission = () => {
    if (!localStorage.getItem('applicantSubmissionUUID')) {

      /* axios.post("/api/application_submission/",
        {
          "json_application_details": JSON.stringify(action.applicantDetails).replace(/"/g, "'")
        }
      )
        .then((response) => {
          console.log(response, "NEW");
          if (response.status === 200) {
            console.log(response.data.application_submissions_uuid);
            const url = `/${response.data.application_submissions_uuid}`;
            localStorage.setItem('applicantSubmissionUUID', response.data.application_submissions_uuid);
          } 
        }).catch(err => {
        }); */
    } else {

       //REMOVE PROPERTIES AFTER DEBTORS
       const newItems = {...action.applicantDetails};
 
       delete newItems.operating_agreement;
       delete newItems.operating_agreement_file;
       delete newItems.operating_agreement_payload;
       
       delete newItems.financials;
       delete newItems.financials_file;
       delete newItems.financials_payload;
  
       delete newItems.open_ar;
       delete newItems.open_ar_file;
       delete newItems.open_ar_payload;
  
       delete newItems.additional_docs;
       delete newItems.additional_docs_files;
       delete newItems.additional_docs_payload;
       
       delete newItems.electronic_communications_disclosure;
       delete newItems.star_disclosure;
       delete newItems.tms_agreement;
  
       console.log(newItems);

      /* axios.post("/api/application_submission/",
        {
          "application_submissions_uuid": localStorage.getItem('applicantSubmissionUUID'),
          "json_application_details": JSON.stringify(action.applicantDetails).replace(/"/g, "'")
        }
      )
        .then((response) => {
          console.log(response, "UPDATE");
          if (response.status === 200) {
            console.log(response.data.application_submissions_uuid);
            localStorage.setItem('applicantSubmissionUUID', response.data.application_submissions_uuid);
          }
        }).catch(err => {
        }); */

    }

  }

  switch (action.type) {
    case actionTypes.SET_USER:
      return {
        ...state,
        user: action.user,
      };
    case actionTypes.SET_REFRESH_APPLICANT:
      return {
        ...state,
        refreshApplicant: action.refreshApplicant,
      };
    case actionTypes.SET_GLOBAL_ACCOUNT_SELECTED:
      return {
        ...state,
        globalAccountSelected: action.globalAccountSelected,
      };
    case actionTypes.SET_SHOW_NOTIFICATION:
      return {
        ...state,
        showNotification: action.showNotification,
      };
    case actionTypes.SET_SHOW_PROCESSING:
      return {
        ...state,
        showProcessing: action.showProcessing,
      };
    case actionTypes.INIT_APPLICANT_DETAILS:
      return {
        ...state,
        applicantDetails: action.applicantDetails,
      };
      case actionTypes.SET_SUBMIT_APPLICANT_DETAILS:
        applicationSubmission();
        return {
          ...state,
          applicantDetails: action.applicantDetails,
        };
    case actionTypes.SET_APPLICANT_DETAILS:
      return {
        ...state,
        applicantDetails: action.applicantDetails,
      };
    case actionTypes.SET_ACTIVE_STEP:
      return {
        ...state,
        activeStep: action.activeStep,
      };
    case actionTypes.SET_GO_TO_STEP:
      return {
        ...state,
        goToStep: action.goToStep,
      };
    case actionTypes.SET_PROGRESS_STEP:
      return {
        ...state,
        progressStep: action.progressStep,
      };
    case actionTypes.SET_HIDE_HAULING:
      return {
        ...state,
        hideHauling: action.hideHauling,
      };
    default:
      return state;
  }
};

export default reducer;
